import { render, staticRenderFns } from "./Equipment_View.vue?vue&type=template&id=77c5c99e&scoped=true&"
import script from "./Equipment_View.vue?vue&type=script&lang=ts&"
export * from "./Equipment_View.vue?vue&type=script&lang=ts&"
import style0 from "./Equipment_View.vue?vue&type=style&index=0&id=77c5c99e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c5c99e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAvatar,VChip,VCol,VContainer,VImg,VRow,VTab,VTabItem,VTabs,VTabsItems})
